import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const UserCheckmarkOutline = createIcon({
  displayName: 'UserCheckmarkOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect xmlns="http://www.w3.org/2000/svg" y="0.00001" width="24" height="24" fill="none" />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11,21H8a5,5,0,0,1-5-5V8A5,5,0,0,1,8,3h8a5,5,0,0,1,5,5v3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="12"
        cy="9.50001"
        r="2.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M7,17H7a2.5,2.5,0,0,1,2.5-2.5H11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        xmlns="http://www.w3.org/2000/svg"
        cx="18"
        cy="18.00001"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M19.25,17.5,17.68831,19,16.75,18.1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const UserCheckmarkTwoTone = createIcon({
  displayName: 'UserCheckmarkTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect xmlns="http://www.w3.org/2000/svg" y="0.00001" width="24" height="24" fill="none" />
      <Box
        as="path"
        xmlns="http://www.w3.org/2000/svg"
        d="M11,21H8a5,5,0,0,1-5-5V8A5,5,0,0,1,8,3h8a5,5,0,0,1,5,5v3"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        xmlns="http://www.w3.org/2000/svg"
        cx="12"
        cy="9.50001"
        r="2.5"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        xmlns="http://www.w3.org/2000/svg"
        d="M7,17H7a2.5,2.5,0,0,1,2.5-2.5H11"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        xmlns="http://www.w3.org/2000/svg"
        cx="18"
        cy="18.00001"
        r="4"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        xmlns="http://www.w3.org/2000/svg"
        d="M19.25,17.5,17.68831,19,16.75,18.1"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const UserCheckmark: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={UserCheckmarkTwoTone} {...props} />

  return <CustomIcon as={UserCheckmarkOutline} {...props} />
}

export default memo(UserCheckmark)
